module.exports = __webpack_public_path__ + "img/send_goods_bg2.7027816b.png";